<template>
  <OmtLayoutContainer class="hub-programas">
    <OmtRow :display="['none', 'flex']">
      <HubBreadcrumb :items="breadcrumb" />
    </OmtRow>
    <OmtRow
      stack
      class="hub-programas__intro"
    >
      <OmtTypography
        as="h1-bold"
        class="hub-programas__title"
        >Programas de saúde</OmtTypography
      >
      <OmtTypography
        as="p1"
        class="hub-programas__subtitle"
        color="var(--colors-light-primary-gray1)"
      >
        Participe dos programas dedicados a você. Veja os detalhes e faça a adesão clicando nos cards:
      </OmtTypography>
    </OmtRow>
    <OmtRow mt="16px">
      <div class="hub-programas__grid">
        <HubOptionCard
          v-for="program in featured"
          :key="program.slug"
          variant="banner"
          :title="program.title"
          :description="program.cardDescription"
          :image="program.image"
          :image-mobile="program.imageMobile"
          :icon="program.icon"
          @click="openProgram(program)"
        />
      </div>
    </OmtRow>

    <OmtRow mt="16px">
      <HubAccordion
        title="Conheça mais programas Omint"
        icon="user-doctor"
        description="A Omint oferece programas de saúde exclusivos para cuidar de você em todas as fases da vida. Conheça as opções disponíveis:"
        toggle-label="Ver programas"
        :default-open="accordionOpen"
      >
        <div class="hub-programas__grid">
          <HubOptionCard
            v-for="program in extras"
            :key="program.slug"
            variant="banner"
            :title="program.title"
            :description="program.cardDescription"
            :image="program.image"
            :image-mobile="program.imageMobile"
            :icon="program.icon"
            @click="openProgram(program)"
          />
        </div>
      </HubAccordion>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import HubAccordion from "@/components/Organisms/HubSaude/HubAccordion.vue";
import HubBreadcrumb from "@/components/Organisms/HubSaude/HubBreadcrumb.vue";
import HubOptionCard from "@/components/Organisms/HubSaude/HubOptionCard.vue";
import { extraPrograms, featuredPrograms } from "@/data/hubSaude";

export default {
  name: "HubSaudeProgramas",
  components: { HubAccordion, HubBreadcrumb, HubOptionCard },
  data() {
    return {
      featured: featuredPrograms,
      extras: extraPrograms,
      accordionOpen: typeof window === "undefined" ? false : window.innerWidth < 1024,
      breadcrumb: [
        { label: "Home", to: "/" },
        { label: "Hub de saúde", to: "/hub-de-saude" },
        { label: "Programas de saúde" }
      ]
    };
  },
  methods: {
    openProgram(program) {
      if (program.route && program.ctaKind === "navigate") {
        this.$router.push(program.route);
        return;
      }
      this.$router.push({ name: "hub_saude.programa", params: { slug: program.slug } });
    }
  }
};
</script>

<style scoped>
.hub-programas {
  width: 100%;
}

.hub-programas__title {
  color: var(--colors-light-primary-navy-blue);
  margin: 0;
}

.hub-programas__subtitle {
  margin: 8px 0 0;
}

.hub-programas__grid {
  display: grid;
  gap: 16px;
  width: 100%;
  align-items: stretch;
}

@media screen and (min-width: 1024px) {
  .hub-programas__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
